module.exports = __webpack_public_path__ + "static/media/fenxsIcon.775a0906.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/fenxsIcon.png
// module id = 1756
// module chunks = 0 1